import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localeFlag'
})
export class LocaleFlagPipe implements PipeTransform {
  transform(locale: string): string {
    let flag: string = locale;

    if(locale.length > 2) {
      flag = locale.split('-').pop() as string;
    }

    return flag.toLowerCase();
  }
}